var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4, _linearGradient5, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUmeeUmeeLogo = function SvgUmeeUmeeLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 172.8 150.3",
    xmlSpace: "preserve"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "umee-umee-logo_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: -13.291,
    y1: 106.327,
    x2: 207.298,
    y2: -9.019
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fda9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.028,
    stopColor: "#f9aaff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.243,
    stopColor: "#dcb3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367,
    stopColor: "#d1b6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#4dffe5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.1 2.9v53.6-2.1c.4 45.8 38.8 84.9 86.3 84.9s85.9-37 86.3-82.8V2.9s-12-5.8-25.6 8.1c-8.7 8.9-15.7 41.1-34.4 41.3-25 .4-42-32.8-62.3-45.2C29.1-5.9.1 2.9.1 2.9z",
    fill: "url(#umee-umee-logo_svg__a)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "umee-umee-logo_svg__b",
    gradientUnits: "userSpaceOnUse",
    x1: 76.719,
    y1: 70.177,
    x2: 99.452,
    y2: -13.176
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#16183c",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#16183c",
    stopOpacity: 0
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.1 2.9v53.6-2.1c.4 45.8 38.8 84.9 86.3 84.9s85.9-37 86.3-82.8V2.9s-12-5.8-25.6 8.1c-8.7 8.9-15.7 41.1-34.4 41.3-25 .4-42-32.8-62.3-45.2C29.1-5.9.1 2.9.1 2.9z",
    fill: "url(#umee-umee-logo_svg__b)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "umee-umee-logo_svg__c",
    gradientUnits: "userSpaceOnUse",
    x1: -5.976,
    y1: 112.594,
    x2: 191.881,
    y2: 25.031
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fda9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.028,
    stopColor: "#f9aaff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.243,
    stopColor: "#dcb3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367,
    stopColor: "#d1b6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#4dffe5"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M172.7 61.7V24.5c-4.9.8-10.9 3.2-17.2 9-9.8 9-17.6 41.5-38.6 41.8-28 .4-47.1-33.2-69.9-45.8-15.9-8.6-35.6-7.6-47-5.9v38.2-2.3c.4 49 38.9 90.8 86.3 90.8 47.5 0 86-39.6 86.4-88.6z",
    fill: "url(#umee-umee-logo_svg__c)"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "umee-umee-logo_svg__d",
    gradientUnits: "userSpaceOnUse",
    x1: 66.553,
    y1: 93.575,
    x2: 96.863,
    y2: 31.271
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#16183c",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#16183c",
    stopOpacity: 0
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M172.7 61.7V24.5c-4.9.8-10.9 3.2-17.2 9-9.8 9-17.6 41.5-38.6 41.8-28 .4-47.1-33.2-69.9-45.8-15.9-8.6-35.6-7.6-47-5.9v38.2-2.3c.4 49 38.9 90.8 86.3 90.8 47.5 0 86-39.6 86.4-88.6z",
    fill: "url(#umee-umee-logo_svg__d)"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "umee-umee-logo_svg__e",
    gradientUnits: "userSpaceOnUse",
    x1: -14.459,
    y1: 125.184,
    x2: 163.191,
    y2: 56.986
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fda9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.028,
    stopColor: "#f9aaff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.243,
    stopColor: "#dcb3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367,
    stopColor: "#d1b6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#4dffe5"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M172.7 61.7v-8.5c-3.7 1.4-7.8 3.7-12 7.3-10.6 9-19 41.5-41.6 41.8-30.2.4-50.7-33.2-75.3-45.8-14.2-7.1-31.4-7.6-43.8-6.6v11.9-2.3c.4 49 38.9 90.8 86.3 90.8 47.5 0 86-39.6 86.4-88.6z",
    fill: "url(#umee-umee-logo_svg__e)"
  })));
};
export { SvgUmeeUmeeLogo as ReactComponent };